// Types
import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const DowngradeReminderAdmin = ({ notification }: NotificationSubscriptionProps) => {
    return (
        <Notification
            dataNotification={notification}
            goToUrl={SUBSCRIPTION_INVOICES}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title
                    i18nKey="commons:notifications.downgrade_reminder_admin.title"
                    values={{ plan_name: notification?.data?.plan_name }}
                />
                <Notification.Description i18nKey="commons:notifications.downgrade_reminder_admin.description" />
            </Notification.Content>
        </Notification>
    );
};

export default DowngradeReminderAdmin;
